
import { routeToBusinessProfileVisitors } from "@/helpers/routing"

import { mdiClose } from "@mdi/js"
import dates from "@/mixins/dates"
export default {
    name: "BusinessViewersSnackbar",
    mixins: [dates],
    data: function () {
        return {
            mdiClose: mdiClose,
            showSnackbar: true,
            loading: false,
            viewsCounter: null,
            viewsFetchedAt: null,
        }
    },
    computed: {
        snackbarText() {
            if (this.viewsFetchedAt === null) {
                return (
                    "Ihr Profil wurde heute " +
                    this.viewsCounter +
                    " mal aufgerufen"
                )
            }
            return (
                "Ihr Profil wurde seit dem letzten Besuch " +
                this.viewsCounter +
                " mal aufgerufen"
            )
        },
        routeToBusinessProfileVisitors() {
            return routeToBusinessProfileVisitors(this.$auth.user?.business)
        },
    },
    mounted() {
        this.loading = true
        this.viewsFetchedAt = localStorage.getItem("business_views_fetched_at")
        let from = this.viewsFetchedAt
            ? this.viewsFetchedAt
            : new Date().setUTCHours(0, 0, 0, 0)
        this.$axios
            .$get(
                "api/oabalytics/business/" +
                    this.$auth.user.business.id +
                    "/views",
                {
                    params: {
                        from: from,
                    },
                }
            )
            .then((response) => {
                this.viewsCounter = response.meta.total
                this.loading = false
                localStorage.setItem(
                    "business_views_fetched_at",
                    new Date().toISOString()
                )
            })
            .catch((error) => {
                console.error(error)
                this.loading = false
            })
    },
    methods: {
        onClick() {
            this.$router.push(this.$auth.user.business.slug + "/profilbesucher")
        },
    },
}
